import { hasPermission } from "./permissionUtils";

const normalizeRole = (role) => (role || "").trim().toLowerCase();

export const canAccessMenuItem = (item, userType, permissions) => {
  const role = normalizeRole(userType);
  if (!role || !item?.module) return false;

  // Admin bootstrap while permissions API is loading
  if (role === "admin" && (!permissions || permissions.length === 0)) {
    if (item.roles?.length) {
      return item.roles.map((r) => r.toLowerCase()).includes("admin");
    }
    return true;
  }

  const action = item.action || "view";
  return hasPermission(permissions, item.module, action);
};

export const getVisibleMenuItems = (menu, userType, permissions) => {
  if (!userType) return [];

  return menu
    .map((item) => {
      if (item.children?.length) {
        const visibleChildren = item.children.filter((child) =>
          canAccessMenuItem(child, userType, permissions)
        );
        if (visibleChildren.length === 0) return null;
        return { ...item, children: visibleChildren };
      }

      return canAccessMenuItem(item, userType, permissions) ? item : null;
    })
    .filter(Boolean);
};

export const splitMenuBySection = (visibleMenu) => {
  const main = visibleMenu.filter((item) => item.section !== "settings");
  const settings = visibleMenu.filter((item) => item.section === "settings");
  return { main, settings };
};

export const flattenMenuItems = (menu) => {
  const items = [];
  menu.forEach((item) => {
    if (item.children?.length) {
      item.children.forEach((child) => items.push({ parent: item, ...child }));
    } else {
      items.push({ parent: null, ...item });
    }
  });
  return items;
};

export const getBreadcrumbsFromMenu = (menu, pathname) => {
  const breadcrumbs = [];
  const pushUnique = (entry) => {
    if (!breadcrumbs.some((b) => b.path === entry.path && b.name === entry.name)) {
      breadcrumbs.push(entry);
    }
  };

  menu.forEach((item) => {
    if (!item.children?.length) {
      if (pathname === item.path || (item.path !== "/" && pathname.startsWith(item.path))) {
        pushUnique(item);
      }
      return;
    }

    item.children.forEach((child) => {
      if (pathname === child.path || pathname.startsWith(`${child.path}/`)) {
        pushUnique({ name: item.name, path: item.path });
        pushUnique(child);
      }
    });
  });

  return breadcrumbs;
};
